module.exports = __webpack_public_path__ + "static/img/32.96af2da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/32.png
// module id = 6489
// module chunks = 1